const config = {
  env: "production",
  apiUrl: "https://api.contactastro.com/api/",
};

export default config;
